export default "__VITE_ASSET__BENvtXXs__"